import type { ThumbnailType } from "lib/types";
import defaultSearchConfig from 'config/search.config';

// A helper to return the query string from a full path with the query at the end.
export const getQs = (url) => {
  if (url) {
    const parts = url.split('?');
    if (parts[1]) {
      return parts[1]
    }
  }

  return '';
}


export const getConfig = (connector, ourFilters) => {
  const config = {
    debug: false,
    apiConnector: connector,
    alwaysSearchOnInitialLoad: false,
    // CR-1448 - fix issue with initial load on client
    neverSearchOnInitialLoad: true,
    searchQuery: { ...defaultSearchConfig.searchQuery, filters: ourFilters },
    autoCompleteQuery: defaultSearchConfig.autocompleteQuery,
  };
  return config;
}

export const getThumbnail = (rawResult, searchType, categoryCode): ThumbnailType => {
  let images = rawResult.images || [];
  const thumb: ThumbnailType = {
    origin: null,
    default:
      searchType === "SCHEME" && categoryCode === "SC"
        ? `${process.env.NEXT_PUBLIC_APP_CDN_URL}fallback-images/scheme-sc-fullback.jpeg`
        : process.env.NEXT_PUBLIC_APP_CDN_URL + "fallback-images/" + categoryCode?.toLowerCase() + "-fullback.jpeg",
    sizes: [200, 400],
  };

  // get the real one
  if (images.length) {
    thumb.origin = "this";
    Object.entries(images[0].format)
      .map((k) => ({ ...images[0].format[k[0]], file_type: k[0].endsWith('wp') ? 'webp' : 'jpg' }))
      .forEach((med) => {
        if (thumb.sizes.includes(med.width)) {
          if (med.file_type in thumb) {
            thumb[med.file_type][med.width] = med.uri;
          } else {
            thumb[med.file_type] = {
              [med.width]: med.uri,
            };
          }
        }
      });

    if (thumb.jpg) {
      thumb.default = thumb.jpg[200] ? thumb.jpg[200] : thumb.jpg[400];
    } else if (thumb.png) { 
      thumb.default = thumb.png[200] 
    } else {
      thumb.origin = null;
    }
  }

  return thumb;
};

